import { render } from "./CompanyChargesModal.vue?vue&type=template&id=49d7509b"
import script from "./CompanyChargesModal.vue?vue&type=script&lang=js"
export * from "./CompanyChargesModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__